import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { API } from "../../shared/apiRoutes";
import { inventoryLocationListType, locationDetailsType, orderDetailsType, ProductModifierType, shippingJson, shippingMethodType, ShippingTypeDetailType, userDetailsType, VariantResponse } from "../../components/orders/orderDetailModule";

export interface intialState {
    getAllDetails: { value: null | OrderDetailsJson, error: string | null },
    updateStatus: { error: string, value: null | updateOrderJson },
    returnRequestOrder: { error: string, value: null | ReturnRequestOrderResponse, loading: boolean },
    returnRequestproduct: { error: string, value: null | any, loading: boolean },
    updateOrderAddress: { error: string, value: null | any },
    getAllDiscount: { error: string, value: discountJson | null },
    updateOrderDiscount: { error: string, value: null | updateDiscountJson },
    addOrderNotes: { error: string, value: null | addNotesJson },
    refundData: { error: string, value: any }
    updateReturnStatus: { error: string, value: UpdateReturnStatusResponse | null, isLoading: boolean }

}

export type UpdateReturnStatusResponse = {
    "updateReturnStatusRes": number[],
    "message": string,
    "statusCode": string,
    "success": boolean
}

export type updateOrderJson =
    {
        "updateOrderDetails": {
            "success": boolean,
            "customerNotification": boolean
        },
        "message": string,
        "statusCode": string,
    }


export type updateOrderPayload =
    {
        orderStatus?: string | number | null,
        orderName?: string,
        orderStatusDate?: string,
        event?: string,
        orderStatusCode?: string,
        todayDate: string,
        modifiedAt: string,
        customizedOrderId?: string | null | undefined,
        isPreOrder: boolean,
        userEmail?: string | null | undefined,
        status?: string,
    }

export type updateAddresPayload =
    {
        "deliveryAddress": {
            "name": string,
            "countryCode": string,
            "addressLine1": string,
            "addressLine2": string | null,
            "contactNumber": string,
            "city": string,
            "country": {
                "id": number,
                "name": string,
                "countryCode": number,
                "countryIsoCode": string
            } | null,
            "state": {
                "id": number,
                "name": string,
                "code": string,
                "countryId": number
            },
            "zipCode": string,
            "shippingMethod": string | null,
            "landmark": string | null,
            "addressType": string | null,
            "otherAddressType": string | null,
            "phone": string
        },
        "modifiedAt": string,
        "customizedOrderId": string,
        "orderStatusValue": "New",
        "orderStatusCode": "NEW",
        "userEmail": string
    }

export type OrderDiscountPayload =
    {
        "products": null,
        "storeId": number,
        "amount": {
            "subTotal": number,
            "productQty": number | null
        },
        "customerId": number,
        "currentDate": string
    }

export type updateDiscountPayload =
    {
        "OrderedProductId": null,
        "productId": null,
        "variantId": null,
        "combinationName": null,
        "orderId": number,
        "storeId": number,
        "orderedProductsList": null,
        "currency": string,
        "quantity": number,
        "event": null,
        "promoCode": string,
        "customerId": number,
        "customizedOrderId": string,
        "modifiedAt": string,
        "userEmail": string,
        "isInclusiveTax": boolean,
        "nameJson": null,
        "variantNameJson": null,
        "currentDate": string
    }

export type addNotesPayload =
    {
        "orderNotesValue"?: string,
        orderNotesPrivacy?: string,
        "id": null | number,
        "orderId": string
        isDeleted?: boolean,
    }

export type dicountType =
    {
        "promoCode": string,
        "description": string | null,
        "appliesTo": number,
        "applicableItems": number | null,
        "discountTypeId": number,
        "discountValue": string,
        "customerEligibilityType": number,
        "restrictionBasedOn": number,
        "minValue": number | null,
        "id": number,
        "overallUsageLimit": number | null,
        "maxAmount": number | null,
        "userBasedMaxUse": number | null,
        "recurrenceDetails": number | null,
        "descriptionJson": any,
        "discountMappings": [],
        "discountType": {
            "discountName": string,
            "discountTypeCode": string
        },
        selected?: boolean
    }

export type discountJson =
    {
        "discounts": {
            categoryLevelDiscounts: [],
            brandLevelDiscounts: [],
            productLevelDiscounts: [],
            orderLevelDiscounts: dicountType[],
            overAllDiscounts: dicountType[]
        }
    }

export type updateDiscountJson =
    {
        "updateOrder": {
            "message": string
        },
        "success": boolean
    }

export type addNotesJson =
    {
        "orderNotes": {
            duplicateEntry: true,
            edit: true,
            create: true
        }
    }

export type productUpdateJson =
    {
        "updateOrder": {
            'message': string
        }
    }

export type OrderDetailsJson =
    {
        getOrderDetails:
        {
            ordersDetails: orderDetailsType,
            userDetails: userDetailsType
            locationDetails: locationDetailsType,
            shippingTypeDetails: ShippingTypeDetailType
        }
    }

export type LoyaltyLogItem = {
    id: number;
    storeId: number;
    customerId: number;
    message: string;
    event: 'Earned' | 'Reduced' | 'Refunded';
    points: string;
    reason: string | null;
    orderId: number;
};

export type LoyaltyLogJson = {
    result: {
        redeemDetails: LoyaltyLogItem[];
        earnDetails: LoyaltyLogItem[];
    };
    message: string;
    statusCode: string;
    success: boolean;
};

export type RefundDetail = {
    id: number;
    refundStatus: string;
    refundType: string;
    refundAmount: number;
    refundReason: string;
    createdAt: string;
};

export type RefundDetailsResponse = {
    result: {
        count: number;
        rows: RefundDetail[];
    };
    msg: string;
    statusCode: string;
    success: boolean;
};

export type InvoiceJson = {
    invoice: { content: { data: any, type: string }, fileName: string } | null;
    statusCode?: string;
    msg?: string;
    message?: string;
    success?: boolean;
}

interface ReturnRequestOrderResponse {
    returnRequestOrderResponse: ReturnRequestOrder[];
    error: string;
    message: string;
    statusCode: string;
    success: boolean;
}

interface ReturnRequestOrder {
    returnQty: number;
    stockRestore: boolean;
    isOrderDeleted: boolean;
    stockRestoredLocationId: number | null;
    createdAt: string;
    modifiedAt: string;
    id: number;
    storeId: number;
    comments: string | null;
    reason: string;
    orderId: number;
    isDeleted: boolean;
    status: string;
    isOrderLevel: boolean;
    productId: number;
    variantId: number;
    combinationName: string;
    action: string;
    orderProductId: number;
    customizedOrderId: string;
    statusId: number | null;
    isViewed: boolean | null;
    isFullyReturn: boolean | null;
    isRefunded: boolean | null;
    returnRequestImages: unknown[];
    productName: string;
    quantity: number;
    imageUrl: string | null;
    orderModifiers: unknown[];
}



const intialState: intialState =
{
    getAllDetails: { error: '', value: null },
    updateStatus: { error: '', value: null },
    updateOrderAddress: { error: '', value: null },
    getAllDiscount: { error: '', value: null },
    updateOrderDiscount: { error: '', value: null },
    addOrderNotes: { error: '', value: null },
    refundData: { error: '', value: null },
    updateReturnStatus: { error: "", value: null, isLoading: false },
    returnRequestOrder: { error: "", value: null, loading: false },
    returnRequestproduct: { error: "", value: null, loading: false },

}

export const getSingleOrderDetails = createAsyncThunk('orders/getAllDetails', ({ storeId, orderId, data, isPos }: { storeId: number, orderId: number, data: { isUser: boolean, currentDate: string }, isPos: boolean }) => {
    const url = HttpRoutingService.replaceUrl(API.singleOrderDetails, { storeId, orderId })
    return HttpRoutingService.getMethod<OrderDetailsJson>(url, data, isPos ? 'v2/' : 'v1/')
})

export const getLoyaltyPointsLog = createAsyncThunk('orders/getLoyaltyPointsLog', ({ storeId, orderId, isPos }: { storeId: number, orderId: number, isPos: boolean }) => {
    const url = HttpRoutingService.replaceUrl(API.loyaltyPointsLog, { storeId: storeId, orderId: orderId })
    return HttpRoutingService.getMethod<LoyaltyLogJson>(url, isPos ? 'v2/' : 'v1/')
})

export const getRefundDetails = createAsyncThunk('orders/refundDetails', ({ storeId, orderId, isPos }: { storeId: number, orderId: number, isPos: boolean }) => {
    const url = HttpRoutingService.replaceUrl(API.getRefundDetails, { storeId: storeId, id: orderId })
    return HttpRoutingService.getMethod<RefundDetailsResponse>(url, isPos ? 'v2/' : 'v1/')
})
export const updateOrderStatus = createAsyncThunk('orders/updateOrderStatus', ({ storeId, orderId, data, isPos }: { storeId: number, orderId: number, data: updateOrderPayload, isPos: boolean }) => {
    const url = HttpRoutingService.replaceUrl(API.singleOrderDetails, { storeId: storeId, id: orderId })
    return HttpRoutingService.putMethod<updateOrderJson>(url, data)
})


export const updateAddress = createAsyncThunk('orders/updateAddress', ({ storeId, orderId, data }: { storeId: number, orderId: number, data: updateAddresPayload }) => {
    const url = HttpRoutingService.replaceUrl(API.singleOrderDetails, { storeId: storeId, id: orderId })
    return HttpRoutingService.putMethod(url, data)
})


export const getOrderDiscount = createAsyncThunk('orders/getOrderDiscount', ({ storeId, data }: { storeId: number, data: OrderDiscountPayload }) => {
    const url = HttpRoutingService.replaceUrl(API.orderDiscount, { storeId: storeId })
    return HttpRoutingService.postMethod<discountJson>(url, data)
})

export const updateDiscount = createAsyncThunk('orders/updateDiscount', ({ storeId, orderId, data, isPos }: { storeId: number, orderId: number, data: updateDiscountPayload, isPos: boolean }) => {
    const url = HttpRoutingService.replaceUrl(API.singleOrderDetails, { storeId: storeId, id: `${orderId}/details` })
    return HttpRoutingService.putMethod<updateDiscountJson>(url, data)
})

export const addNotes = createAsyncThunk('orders/addNotes', ({ storeId, data, isPos }: { storeId: number, data: addNotesPayload, isPos: boolean }) => {
    const url = HttpRoutingService.replaceUrl(API.orderNotes, { storeId: storeId })
    return HttpRoutingService.postMethod<addNotesJson>(url, data)
})

export const getOrderedProductVariant = createAsyncThunk('orders/productOption', ({ storeId, productId, data }: { storeId: number, productId: number, data: any }) => {
    const url = HttpRoutingService.replaceUrl(API.productVariant, ({ storeId: storeId, productId: productId }))
    return HttpRoutingService.getMethod<VariantResponse>(url, data, 'v1/')
})

export const updateProductOptionVariants = createAsyncThunk('orders/updateOption', ({ storeId, orderId, data, isPos }: { storeId: number, orderId: number, data: any, isPos: boolean }) => {
    const url = HttpRoutingService.replaceUrl(API.singleOrderDetails, ({ storeId: storeId, id: `${orderId}/details` }))
    return HttpRoutingService.putMethod<productUpdateJson>(url, data)
})

export const getOrderedProductModifiers = createAsyncThunk('orders/productModifiers', ({ storeId, productId, variantId }: { storeId: number, productId: number, variantId: number }) => {
    const url = HttpRoutingService.replaceUrl(API.productModifiers, { storeId: storeId, productId: productId, variantId: variantId })
    return HttpRoutingService.getMethod<{ result: ProductModifierType }>(url, {}, 'v1/')
})

export const updateOrderedProductModifiers = createAsyncThunk('orders/updatemodifiers', ({ storeId, orderId, data }: { storeId: number, orderId: number, data: any }) => {
    const url = HttpRoutingService.replaceUrl(API.singleOrderDetails, ({ storeId: storeId, id: `${orderId}/details` }))
    return HttpRoutingService.putMethod<productUpdateJson>(url, data)
})

export const updateOrderedTracking = createAsyncThunk('orders/updateTracking', ({ storeId, orderId, data }: { storeId: number, orderId: number, data: any }) => {
    const url = HttpRoutingService.replaceUrl(API.singleOrderDetails, ({ storeId: storeId, id: `${orderId}/track` }))
    return HttpRoutingService.putMethod<productUpdateJson>(url, data)
})

export const updateRefundAmount = createAsyncThunk('order/updateRefund', ({ storeId, data }: { storeId: number, data: any }) => {
    const Url = HttpRoutingService.replaceUrl(API.orderRefund, { storeId: storeId })
    return HttpRoutingService.postMethod(Url, data)
})

export const updateLoyaltyPoints = createAsyncThunk('order/updateLoyalty', ({ storeId, customerId, data }: { storeId: number, customerId: number, data: any }) => {
    const Url = HttpRoutingService.replaceUrl(API.orderLoyalty, { storeId: storeId, customerId: customerId })
    return HttpRoutingService.putMethod(Url, data)
})

export const getShippingDetails = createAsyncThunk('order/getShipppingList', ({ storeId, orderId, data }: { storeId: number, orderId: number, data: any }) => {
    const Url = HttpRoutingService.replaceUrl(API.orderShipping, { storeId: storeId, orderId: orderId })
    return HttpRoutingService.getMethod<shippingJson>(Url, data, 'v1/')
})

export const updateOrderShipping = createAsyncThunk('order/updateShipping', ({ storeId, data }: { storeId: number, data: any }) => {
    const Url = HttpRoutingService.replaceUrl(API.updateOrderShipping, { storeId: storeId })
    return HttpRoutingService.putMethod(Url, data)
})

export const returnRequestproduct = createAsyncThunk('orders/returnRequest', ({ storeId, orderId, productId, data }: { storeId: number, orderId: number, productId: number, data: any }) => {
    const Url = HttpRoutingService.replaceUrl(API.returnProduct, { storeId: storeId, orderId: orderId, productId: productId })
    return HttpRoutingService.postMethod(Url, data)

})

export const returnRequestOrder = createAsyncThunk('orders/returnOrder', ({ storeId, orderId, data }: { storeId: number, orderId: number, data: any }) => {
    const Url = HttpRoutingService.replaceUrl(API.returnOrder, { storeId: storeId, orderId: orderId })
    return HttpRoutingService.postMethod<ReturnRequestOrderResponse>(Url, data)
})

export const restoreInventoryLocation = createAsyncThunk('order/restoreInventoryLocation', ({ storeId, data }: { storeId: number, data: any }) => {
    const Url = HttpRoutingService.replaceUrl(API.restoreInventoryLocation, { storeId })
    return HttpRoutingService.getMethod<inventoryLocationListType>(Url, data, 'v1/')
})

export const updateReturnProductStatus = createAsyncThunk('order/updateReturnProductStatus', ({ storeId, orderId, returnId, data }: { storeId: number, orderId: number, returnId: number, data: any }) => {
    const Url = HttpRoutingService.replaceUrl(API.updateReturnProductStatus, { storeId: storeId, orderId: orderId, returnId: returnId })
    return HttpRoutingService.putMethod<UpdateReturnStatusResponse>(Url, data)
})

export const restoreStock = createAsyncThunk('order/restoreStock', ({ storeId, orderId, data, AllProducts }: { storeId: number, orderId: number, data: any, AllProducts: boolean }) => {
    const Url = HttpRoutingService.replaceUrl(AllProducts ? API?.singleOrderDetails : API.updateReturnProduct, { storeId: storeId, id: orderId })
    return HttpRoutingService.putMethod(Url, data)
})

export const orderInvoice = createAsyncThunk('order/orderInvoice', ({ data }: { data: { id: string, orderedDate: string, value: boolean, isStoreAdmin: boolean } }) => {
    return HttpRoutingService.postMethod<InvoiceJson>(API.orderInvoice, data)
})


const orderDetails = createSlice({
    initialState: intialState,
    name: 'orders',
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(getSingleOrderDetails.fulfilled, (state, action) => {
                state.getAllDetails.value = action.payload
            })

            .addCase(getSingleOrderDetails.rejected, (state, action) => {
                state.getAllDetails.error = action.error.message as string
            })

            .addCase(updateOrderStatus.fulfilled, (state, action) => {
                state.updateStatus.value = action.payload
            })

            .addCase(updateOrderStatus.rejected, (state, action) => {
                state.updateStatus.error = action.error.message as string
            })

            .addCase(returnRequestOrder.pending, (state, action) => {
                state.returnRequestOrder.loading = true
            })
            .addCase(returnRequestOrder.fulfilled, (state, action) => {
                state.returnRequestOrder.loading = false
                state.returnRequestOrder.value = action.payload
            })
            .addCase(returnRequestOrder.rejected, (state, action) => {
                state.returnRequestOrder.loading = false
                state.returnRequestOrder.error = action.error.message as string
            })

            .addCase(returnRequestproduct.pending, (state, action) => {
                state.returnRequestproduct.loading = true
            })
            .addCase(returnRequestproduct.fulfilled, (state, action) => {
                state.returnRequestproduct.loading = false
                state.returnRequestproduct.value = action.payload
            })
            .addCase(returnRequestproduct.rejected, (state, action) => {
                state.returnRequestproduct.loading = false
                state.returnRequestproduct.error = action.error.message as string
            })

            .addCase(updateAddress.fulfilled, (state, action) => {
                state.updateOrderAddress.value = action.payload
            })

            .addCase(updateAddress.rejected, (state, action) => {
                state.updateOrderAddress.error = action.error.message as string
            })

            .addCase(getOrderDiscount.fulfilled, (state, action) => {
                state.getAllDiscount.value = action.payload
            })

            .addCase(getOrderDiscount.rejected, (state, action) => {
                state.getAllDiscount.error = action.error.message as string
            })

            .addCase(updateDiscount.fulfilled, (state, action) => {
                state.updateOrderDiscount.value = action.payload
            })

            .addCase(updateDiscount.rejected, (state, action) => {
                state.updateOrderDiscount.error = action.error.message as string
            })

            .addCase(addNotes.fulfilled, (state, action) => {
                state.addOrderNotes.value = action.payload
            })

            .addCase(addNotes.rejected, (state, action) => {
                state.addOrderNotes.error = action.error.message as string
            })

            .addCase(updateRefundAmount.fulfilled, (state, action) => {
                state.refundData.value = action.payload
            })
            .addCase(updateRefundAmount.rejected, (state, action) => {
                state.refundData.error = action.error.message as string
            })

            .addCase(updateReturnProductStatus.pending, (state, action) => {
                state.updateReturnStatus.isLoading = true
            })
            .addCase(updateReturnProductStatus.fulfilled, (state, action) => {
                state.updateReturnStatus.value = action.payload
                state.updateReturnStatus.isLoading = false
            })
            .addCase(updateReturnProductStatus.rejected, (state, action) => {
                state.updateReturnStatus.isLoading = false
                state.updateReturnStatus.error = action.error.message as string
            })
    },
})

export default orderDetails.reducer